const FOCAVEIS = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type=hidden])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
  '[contenteditable="true"]',
].join(",");

function focaveisDe(el) {
  return Array.from(el.querySelectorAll(FOCAVEIS)).filter((e) => {
    if (e.getAttribute("aria-hidden") === "true") return false;
    const r = e.getBoundingClientRect();
    return r.width > 0 || r.height > 0 || e === document.activeElement;
  });
}

function conteudoDe(el) {
  return el.closest(".v-dialog") || el;
}

function prender(caixa) {
  return (evento) => {
    if (evento.key !== "Tab") return;
    const lista = focaveisDe(caixa);
    if (!lista.length) {
      evento.preventDefault();
      caixa.focus();
      return;
    }
    const primeiro = lista[0];
    const ultimo = lista[lista.length - 1];
    const atual = document.activeElement;
    if (evento.shiftKey && (atual === primeiro || !caixa.contains(atual))) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && atual === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  };
}

function focoInicial(caixa) {
  const fechar = caixa.querySelector(".btn-fechar-modal");
  const lista = focaveisDe(caixa);
  const alvo = lista.find((e) => e !== fechar) || fechar || lista[0];
  if (alvo) {
    alvo.focus();
  } else {
    caixa.setAttribute("tabindex", "-1");
    caixa.focus();
  }
}

function ativar(el) {
  if (el.__modalAtivo) return;
  const caixa = conteudoDe(el);
  caixa.setAttribute("aria-modal", "true");
  if (!caixa.getAttribute("role")) caixa.setAttribute("role", "dialog");

  el.__modalAtivo = true;
  el.__modalOrigem = document.activeElement;
  el.__modalCaixa = caixa;
  el.__modalTrap = prender(caixa);
  caixa.addEventListener("keydown", el.__modalTrap);
  window.setTimeout(() => focoInicial(caixa), 50);
}

function desativar(el) {
  if (!el.__modalAtivo) return;
  if (el.__modalCaixa && el.__modalTrap) {
    el.__modalCaixa.removeEventListener("keydown", el.__modalTrap);
  }
  const origem = el.__modalOrigem;
  if (origem && document.body.contains(origem) && origem.focus) {
    window.setTimeout(() => origem.focus(), 0);
  }
  el.__modalAtivo = false;
  delete el.__modalTrap;
  delete el.__modalCaixa;
  delete el.__modalOrigem;
}

function aberto(binding) {
  return binding.value === undefined ? true : !!binding.value;
}

export default {
  inserted(el, binding) {
    if (aberto(binding)) ativar(el);
  },
  componentUpdated(el, binding) {
    if (aberto(binding)) ativar(el);
    else desativar(el);
  },
  update(el, binding) {
    if (aberto(binding)) ativar(el);
    else desativar(el);
  },
  unbind(el) {
    desativar(el);
    delete el.__modalAtivo;
  },
};
